<!--<template src="@/templates/reports/jobs.html"></template>-->
<template src="@/templates/footerLink.html"></template>

<script>
    import JobsItem from "@/components/reports/JobsItem"
    import JobsCollection from "@/collections/jobsCollection";
    import SearchModel from "@/models/searchBookingModel";
    import moment from 'moment';
    import XLSX from 'xlsx'
    import {commonFunctions} from "../../common/commonFunctions";

    export default {
        name: "reportJobs",
        components: {
            JobsItem
        },
        data() {
            return {
                jobsCollection: new JobsCollection,
                searchModel: new SearchModel,
                total: 0,
                totalRecordsLabel: 0,
                recordFrom: 0,
                recordTo: 0,
                pageSize: 50,
                currentPage: 1,
                tableHeaderData: [],
                dataForJobsTable: {},
                stylesForJobsTable: {},
                currentSort: {
                    column: "null",
                    order: "null"
                },
                currentActiveTab: 'language',
                defaultTabs: [
                    {
                        key: 'language',
                        label: 'Language'
                    },
                    {
                        key: 'type',
                        label: 'Type'
                    },
                    {
                        key: 'status',
                        label: 'Status'
                    },
                    {
                        key: 'location',
                        label: 'Location'
                    },
                    {
                        key: 'clockedonstatus',
                        label: 'Clocked On Status'
                    }
                ],
                defaultTableHeader: [
                    {
                        key: 'id',
                        label: 'Ref No',
                        data: [],
                        colWid: [24, 2]
                    },
                    {
                        key: 'location',
                        label: 'Location',
                        data: [],
                        colWid: [24, 4]
                    },
                    {
                        key: 'language',
                        label: 'Language',
                        data: [],
                        colWid: [24, 2]
                    },
                    {
                        key: 'interpreter_name',
                        label: 'Interpreter Name',
                        data: [],
                        colWid: [24, 3]
                    },
                    {
                        key: 'serviceDate',
                        label: 'Date',
                        data: [],
                        colWid: [24, 2]
                    },
                    {
                        key: 'serviceTimeStart',
                        label: 'Start',
                        data: [],
                        colWid: [24, 1]
                    },
                    {
                        key: 'serviceTimeEnd',
                        label: 'Finish',
                        data: [],
                        colWid: [24, 1]
                    },
                    {
                        key: 'CALD',
                        label: 'CALD',
                        data: [],
                        colWid: [24, 3]
                    },
                    {
                        key: 'requested_by',
                        label: 'Requested By',
                        data: [],
                        colWid: [24, 2]
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        data: [],
                        colWid: [24, 1]
                    },
                    {
                        key: 'job_type',
                        label: 'Job',
                        data: [],
                        colWid: [24, 1]
                    },
                    {
                        key: 'clockedonstatus',
                        label: 'Clocked On Status',
                        data: [],
                        colWid: [24, 2]
                    }
                ],
                styleProperty: 'width: ',
                stylePropertyValue: ' !important'
            }
        },
        created() {
            this.setFinancialYear();
            this.reloadData();
        },
        methods: {
            reloadData(clearPager) {
                this.setTableHeader();
                this.getJobList(clearPager);
            },
            setFinancialYear() {
                this.searchModel.startServiceDate = commonFunctions.getFinancialYear("Start");
                this.searchModel.endServiceDate = commonFunctions.getFinancialYear("End");
            },
            setTableHeader() {
                this.tableHeaderData = [];

                let thisComponent = this;
                this.defaultTableHeader.forEach(function (item) {
                    if (item.key === thisComponent.$route.query.reportFor) {
                        thisComponent.tableHeaderData.unshift(item);
                    }
                    else {
                        thisComponent.tableHeaderData.push(item);
                    }
                });

                this.defaultTabs.forEach(function (item) {
                    if (item.key === thisComponent.$route.query.reportFor) {
                        thisComponent.currentActiveTab = item.key
                    }
                });
            },
            changeTabs(tab) {
                this.$router.push({query: {reportFor: tab.name}});

                let thisComponent = this;
                setTimeout(function () {
                    thisComponent.reloadData();
                }, 100);
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.reloadData();
            },
            getJobList(clearPager) {
                if (clearPager) {
                    this.total = 0;
                    this.currentPage = 1;
                }

                this.searchModel.validate().then(response => {
                    let errorExists = false;
                    for (let item in response) {
                        if (item != null) {
                            errorExists = true;
                            break;
                        }
                    }
                    if (!errorExists) {
                        let localThis = this;
                        let url = this.$localApiURL + this.jobsCollection.getRoute("fetch");
                        let params = this.getPostParams();

                        this.$http.post(url, params).then(function (response) {
                            if (response.data !== null && response.data !== {}) {
                                let result = response.data;
                                localThis.totalRecordsLabel = parseInt(result.total ? result.total : "0");
                                if (localThis.pageSize === 0) {
                                    localThis.total = 0;
                                    localThis.recordFrom = 1;
                                    localThis.recordTo = localThis.totalRecordsLabel;
                                } else {
                                    localThis.total = localThis.totalRecordsLabel;
                                }
                                let pageSizeEnd = (localThis.pageSize * localThis.currentPage);
                                // localThis.jobsData = result.data;

                                localThis.setJobData(result.data);

                                localThis.recordFrom = localThis.totalRecordsLabel === 0 ? localThis.totalRecordsLabel : (localThis.pageSize * (localThis.currentPage - 1)) + 1;
                                localThis.recordTo = pageSizeEnd >= localThis.totalRecordsLabel || pageSizeEnd === 0 ? localThis.totalRecordsLabel : pageSizeEnd;
                                // localThis.updateJobStatus(localThis.jobsData);
                            } else {
                                localThis.total = 0;
                                localThis.jobsData = [];
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                }).catch(function (error) {
                    console.error(error);
                });
            },
            exportData: function () {
                let url = this.$localApiURL + this.jobsCollection.getRoute("fetch");
                let params = this.getPostParams(true);
                let self = this;
                this.$http.post(url, params).then(function (response) {
                    let result = response.data;
                    let data = result.data;

                    if (data !== null && data.length > 0) {
                        let momentDate = moment(new Date()).format("YYYYMMDDHHmmss");
                        let fileName = "export_" + momentDate.toString() + ".xlsx";
                        let exportData = [];
                        let index;
                        for (index in data) {
                            let attributes = data[index];


                            attributes.bookingStatus = "Assigned";
                            if (attributes.Cancellation === "1") {
                                attributes.bookingStatus = 'Cancelled';
                            } else if (attributes.int_id === "001") {
                                attributes.bookingStatus = 'Waiting to Assign Interpreter';
                            } else if (attributes.int_id === "" || attributes.int_id === "004" || attributes.int_id === "005") {
                                attributes.bookingStatus = 'Waiting to Assign Interpreter';
                            } else if (attributes.not_serviced === "1") {
                                attributes.bookingStatus = 'Not Serviced';

                            }
                            self.processJobTypeRules(attributes);
                            self.removeUnnecessaryFields(attributes);

                            exportData.push(attributes);
                        }
                        let worksheet = XLSX.utils.json_to_sheet(exportData, {
                            header: ["ref_num",
                                "serviceDate",
                                "serviceTimeStart",
                                "serviceTimeEnd",
                                "language",
                                "location_address_1",
                                "location_address_2",
                                "location_name",
                                "suburb",
                                "interpreter_name",
                                "CALD",
                                "job_type",
                                "cpnNumber",
                                "certification",
                                "naati_number",
                                "accreditation",
                                "bookingStatus"]


                        });
                        let wb = XLSX.utils.book_new(); // make Workbook of Excel
                        XLSX.utils.book_append_sheet(wb, worksheet, 'data');
                        XLSX.writeFile(wb, fileName);
                    } else {
                        alert("No data to export");
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            removeUnnecessaryFields(attributes) {
                delete attributes.id;
                delete attributes.int_id;
                delete attributes.not_serviced;
                delete attributes.activityStatus;
                delete attributes.is_clocked_on;
                delete attributes.is_clocked_off;
                delete attributes.early_clock_off;
                delete attributes.is_not_started;
                delete attributes.is_late_clocked_on;
                delete attributes.is_late_sms_sent;
                delete attributes.Cancellation;
                delete attributes.requested_by;
                delete attributes.jobTypeClass;
                delete attributes.jobTypeText;
                delete attributes.statusClass;
                delete attributes.nesbs;
                delete attributes.interpreter_id;
                delete attributes.jobSessionId;
                delete attributes.selected;
                delete attributes.service_date_safari;
                delete attributes.start_safari;
                delete attributes.end_safari;
                delete attributes.cpnNumberLabel;
                delete attributes.location;
            },
            getPostParams(isExport = false) {
                let startServiceDate = this.searchModel.startServiceDate;
                let endServiceDate = this.searchModel.endServiceDate;
                let pageSize = (isExport) ? 0 : this.pageSize;
                return {

                    startServiceDate: (startServiceDate !== null && startServiceDate !== "") ? moment(this.searchModel.startServiceDate).format("YYYYMMDD") : "null",
                    endServiceDate: (endServiceDate !== null && endServiceDate !== "") ? moment(this.searchModel.endServiceDate).format("YYYYMMDD") : "null",
                    status: (this.searchModel.statusFilterValue !== null && this.searchModel.statusFilterValue !== "") ? this.searchModel.statusFilterValue : "null",
                    search: (this.searchModel.search !== null && this.searchModel.search !== "") ? this.searchModel.search : "null",
                    searchFilter: this.searchModel.attributes,
                    currentPage: this.currentPage,
                    pageSize: pageSize,
                    sortColumn: this.currentSort.column,
                    sortOrder: this.currentSort.order,
                    token: localStorage.getItem("jwt")
                };
            },
            setJobData(data) {

                this.jobsData = [];

                let self = this;

                let dataForJobsTable = [];
                let stylesForJobsTable = [];
                data.forEach(function (dataItem, dataKey) {

                    self.processJobTypeRules(dataItem);
                    self.processJobStatusRules(dataItem);
                    self.processActivityStatusRules(dataItem);
                    let orderedDataRow = {};
                    let colStyle = {};
                    self.tableHeaderData.forEach(function (itemTHD, keyTHD) {
                        colStyle[itemTHD.key] = itemTHD.colWid;
                        if (itemTHD.key === 'serviceDate') {

                            orderedDataRow[itemTHD.key] = moment(dataItem[itemTHD.key]).format('D MMM YYYY');
                        }
                        else {
                            orderedDataRow[itemTHD.key] = dataItem[itemTHD.key];
                        }
                    });
                    stylesForJobsTable.push(colStyle);
                    dataForJobsTable.push(orderedDataRow);
                });

                this.dataForJobsTable = dataForJobsTable;
                this.stylesForJobsTable = stylesForJobsTable;
            },
            processJobStatusRules(job) {
                job.status = {
                    class: "far fa-smile",
                    style: 'color: #30bd1a'
                };
                if (job.Cancellation === "1") {
                    job.status = {
                        class: 'fas fa-times',
                        style: 'color: #db4725'
                    };
                } else if (job.int_id === "001") {
                    job.status = {
                        class: 'fas fa-frown',
                        style: 'color: #db4725'
                    };
                } else if (job.int_id === "" || job.int_id === "004" || job.int_id === "005") {
                    job.status = {
                        class: 'far fa-hourglass',
                        status: 'color: #d1b33d'
                    };
                } else if (job.not_serviced === "1") {
                    job.status = {
                        class: 'fas fa-tools',
                        style: ''
                    };
                }
            },
            processJobTypeRules(job) {
                switch (job.job_type.toLowerCase()) {
                    case "ph int":
                        job.job_type = {
                            type: "ph int",
                            jobTypeClass: "fas fa-phone",
                            jobTypeText: "Telephone interpreting"
                        };
                        break;
                    case "trans":
                        job.job_type = {
                            type: "trans",
                            jobTypeClass: "fas fa-language",
                            jobTypeText: "Translation"
                        };
                        break;
                    case "video":
                        job.job_type = {
                            type: "video",
                            jobTypeClass: "fas fa-video",
                            jobTypeText: "Video Interpreting"
                        };
                        break;
                    case "inter":
                        job.job_type = {
                            type: "inter",
                            jobTypeClass: "fas fa-user-friends",
                            jobTypeText: "Interpreting"
                        };
                        break;
                    default:
                        job.job_type = {
                            type: "",
                            jobTypeClass: "fas fa-question",
                            jobTypeText: "Unknown job type"
                        };
                        break;
                }
            },

            processActivityStatusRules(job) {
                let currentDate = new Date();
                let strDateStart = job.service_date_safari + ' ' + job.start_safari;
                let strDateEnd = job.service_date_safari + ' ' + job.end_safari;

                let dateTimeStart = (Date.parse(strDateStart) / 1000).toFixed();
                let dateTimeEnd = (Date.parse(strDateEnd) / 1000).toFixed();

                const dateObjN = new Date();
                let dateNow = (dateObjN / 1000).toFixed();

                const dateObjP = new Date(strDateStart);
                const minus30FromServiceStartTime = dateObjP.setMinutes(dateObjP.getMinutes() - 30);
                const minus30Date = new Date(minus30FromServiceStartTime);

                let calculateMinusDateTime = (minus30Date / 1000).toFixed();

                if (job.is_clocked_off === "1") {

                    job.clockedonstatus = {
                        activityStatus: "circleGreenOk clockOff" // clock off
                    };

                }
                else if (job.service_date < currentDate) {
                    job.clockedonstatus = {
                        activityStatus: "circleRed" // old service date.
                    };
                }
                else if (job.is_clocked_on === "0") {

                    /** Condition 1: Job start not in the future or Job end is not in the past **/
                    if (dateNow > dateTimeStart && dateNow < dateTimeEnd) {
                        /** Job is within Start and End Time **/
                        // console.log('Job is within Start and End Time');
                        job.clockedonstatus = {
                            activityStatus: "circleRed"
                        };
                    }
                    else if (dateNow <= dateTimeStart && calculateMinusDateTime <= dateNow) {
                        /** Job is within 30 minutes of start **/
                        // console.log('Job is within 30 minutes of start');
                        job.clockedonstatus = {
                            activityStatus: "within30Minutes"
                        };
                    }
                    else {
                        /** Job is not within Start and End Time **/
                        // console.log('Job is not within Start and End Time');
                        job.clockedonstatus = {
                            activityStatus: "notWithinTimeRange"
                        };
                    }

                    if (job.is_late_sms_sent === "1") {
                        job.clockedonstatus = {
                            activityStatus: "circleOrange" // late sms
                        };
                    }
                    else if (job.is_not_started === "1" || job.is_late_clocked_on === "1") {
                        job.clockedonstatus = {
                            activityStatus: "circleAmber" // not started or late clock on
                        };
                    }
                } else {
                    job.clockedonstatus = {
                        activityStatus: "circleGreen" // clocked on
                    };
                }
            },
            widthCalculation(colWidth) {
                switch (colWidth[0]) {
                    case 2: {
                        console.log('8.5%');
                        return this.returnStyle('8.5%');
                        break;
                    }
                }
            },
            returnStyle(value) {
                return this.styleProperty + value + this.stylePropertyValue
            }
        }
    }
</script>

<style scoped>
    .customTabAppearance >>> .nav-tabs .nav-item {
        border: none !important;
        padding: 0 5px;
        height: 44px !important;
    }

    .customTabAppearance >>> .nav-tabs .nav-link {
        border-color: #dee2e6 #dee2e6 #fff;
    }

    .customTabAppearance >>> .nav-tabs .nav-link:active {
        color: #e6a23c !important;
    }

    .customTabAppearance >>> .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        color: #e6a23c !important;
        background-image: linear-gradient(#ffd3a438, rgba(255, 255, 255, 0.2) 75%);
    }
</style>



// WEBPACK FOOTER //
// src/components/reports/ReportJobs.vue